<div class="topbar">

  <!-- Start: hamburger + page title -->
  <div class="topbar-start">
    <button
      class="topbar-menu-btn"
      (click)="toggleMenu()"
      pRipple
      aria-label="Toggle navigation">
      <i class="pi pi-bars"></i>
    </button>
    <span class="page-title">{{ pageTitle }}</span>
  </div>

  <!-- End: actions + user profile -->
  <div class="topbar-end">

    <!-- Account selector -->
    <div class="topbar-account">
      <i class="pi pi-building account-icon"></i>
      @if (accounts().length > 1) {
        <p-select [options]="accounts()" [ngModel]="selectedAccountId()"
          (ngModelChange)="onAccountChange($event)"
          optionLabel="accountAbbreviation" optionValue="accountId"
          appendTo="body" styleClass="account-dropdown" />
      } @else {
        <span class="account-name">{{ accounts()[0]?.accountAbbreviation ?? 'No Account' }}</span>
      }
    </div>

    <!-- Divider -->
    <span class="topbar-divider"></span>

    <!-- Color palette picker -->
    <button
      class="topbar-action-btn"
      (click)="palettePanel.toggle($event)"
      pRipple
      pTooltip="Theme color"
      tooltipPosition="bottom">
      <i class="pi pi-palette"></i>
    </button>

    <!-- Dark mode toggle -->
    <button
      class="topbar-action-btn"
      (click)="toggleDark()"
      pRipple
      [pTooltip]="isDark ? 'Light mode' : 'Dark mode'"
      tooltipPosition="bottom">
      <i class="pi" [class.pi-moon]="!isDark" [class.pi-sun]="isDark"></i>
    </button>

    <!-- Divider -->
    <span class="topbar-divider"></span>

    <!-- User profile -->
    <button class="user-profile-btn" (click)="userMenu.toggle($event)" pRipple [disabled]="signingOut()">
      @if (signingOut()) {
        <i class="pi pi-spin pi-spinner user-avatar-spinner"></i>
      } @else {
        <p-avatar
          [label]="userInitials"
          shape="circle"
          styleClass="user-avatar" />
      }
      <div class="user-info">
        <span class="user-name">{{ signingOut() ? 'Signing out…' : userName }}</span>
        <span class="user-role">{{ userRole }}</span>
      </div>
      <i class="pi pi-angle-down chevron"></i>
    </button>
    <p-menu #userMenu [model]="userMenuItems" [popup]="true" appendTo="body">
      <ng-template #end>
        <div class="menu-version">
          <span class="menu-version-num">Version: v{{ appVersion }}</span>
          <span class="menu-version-date">Released: {{ releaseDate }}</span>
        </div>
      </ng-template>
    </p-menu>

  </div>
</div>

<!-- Account switch confirmation dialog -->
<p-confirmdialog key="account-switch" [style]="{ width: '28rem' }" [closable]="false">
  <ng-template #message let-message>
    <div class="account-switch-message">
      <p class="account-switch-note">Note :</p>
      <div [innerHTML]="message.message"></div>
    </div>
  </ng-template>
</p-confirmdialog>

<!-- Color palette popover -->
<p-popover #palettePanel styleClass="palette-panel" appendTo="body">
  <div class="palette-popover">
    <p class="palette-title">Theme Color</p>
    <div class="palette-grid">
      @for (p of theme.palettes; track p.key) {
        <button
          class="swatch-btn"
          [class.active]="theme.activePalette() === p.key"
          [style.background]="p.swatch"
          [pTooltip]="p.label"
          tooltipPosition="top"
          (click)="selectPalette(p.key); palettePanel.hide()">
          @if (theme.activePalette() === p.key) {
            <i class="pi pi-check"></i>
          }
        </button>
      }
    </div>

    <div class="palette-divider"></div>

    <p class="palette-title">Preset</p>
    <div class="preset-btns">
      @for (preset of presets; track preset.key) {
        <button
          class="preset-btn"
          [class.active]="theme.activePreset() === preset.key"
          (click)="selectPreset(preset.key)">
          {{ preset.label }}
        </button>
      }
    </div>
  </div>
</p-popover>
